// Module
var code = "<div class=\"shop-display\">\r\n  <img src=\"https://woofles-images.s3.ap-southeast-2.amazonaws.com/shop-displays/NZ-Black-Logo.png\" />\r\n</div>";
// Exports
module.exports = code;